import * as React from 'react';
import appConfig from '@consumer-talent.config/appConfig';
import styled from 'styled-components';

type StyledLogoProps = {
  alt: string;
};

export const StyledLogo = styled.span<StyledLogoProps>`
  width: 9.375rem;
  height: 2.25rem;
  margin-right: 0;
  display: inline-block;
  background: url(${appConfig.cdnRoot}/images/logos/cn-horizontal.svg) 0 0.125rem no-repeat;
  background-size: contain;
  position: relative;
  top: 0.375rem;
`;

// we should rework this component to use an img tag instead of a span with a background image
export default function (): JSX.Element {
  return <StyledLogo alt={appConfig.companyName} />;
}
